import {
  createBrowserCredentialProvider,
  type CredentialProvider,
} from "./OperatorAuthController";

export class BrowserCredentialProvider implements CredentialProvider {
  readonly #provider = createBrowserCredentialProvider();

  isAvailable(): boolean {
    return this.#provider.isAvailable();
  }

  async getAssertion(options: Readonly<Record<string, unknown>>, signal: AbortSignal): Promise<Readonly<Record<string, unknown>>> {
    return await this.#provider.getAssertion(options, signal);
  }
}
